import React from 'react';

import classes from './IconList.css'

import dateIcon from '../../../../assets/images/date@3x.png';
import menuIcon from '../../../../assets/images/menu@3x.png';
import nameIcon from '../../../../assets/images/nome@3x.png';
import peopleIcon from '../../../../assets/images/people@3x.png';
import positionIcon from '../../../../assets/images/position@3x.png';
import Icon from '../../Icons/index';

const getIcons = (labels) => ([
  {
    icon: positionIcon,
    id: 0,
    name: 'location',
    label: labels.label_store_selection_step
  },
  {
    icon: peopleIcon,
    id: 1,
    name: 'people',
    label: labels.label_people_selection_step
  },
  {
    icon: dateIcon,
    id: 2,
    name: 'data',
    label: labels.label_datetime_selection_step
  },
  {
    icon: menuIcon,
    id: 3,
    name: 'menu',
    label: labels.label_promotion_selection_step
  },
  {
    icon: nameIcon,
    id: 4,
    name: 'other',
    label: labels.label_personal_data_step
  }
]);

const IconTemplate = (props) => {
  const currentPageId = props.currentActive;
  const isActive = props.iconId === currentPageId;
  const wasPassed = props.iconId < currentPageId;
  const isLast = props.iconId === 4;
  let iconFill = '#dddddd';
  if (isActive) {
    iconFill = '#BDD053'
  } else if (wasPassed) {
    iconFill = '#464041'
  }

  return (
    <div className={props.iconId === 4 ? classes.StepBlockContainerLastElement : classes.StepBlockContainer}>
      <div className={[classes.Step, isActive ? classes.ActiveStep : '', wasPassed ? classes.OldStep : ''].join(' ')}>
        <Icon name={props.name} className={[classes.StepsIcon, isActive && classes.StepsIconActive].join(' ')} fill={iconFill} />
        <p className={classes.StepLabel}>{props.label}</p>
      </div>
      {!isLast &&
        <div className={classes.StepsLineContainer}>
          <div className={[classes.StepsLine, wasPassed ? classes.StepsLineActive : {}].join(' ')}></div>
        </div>
      }
    </div>
  );
};

const iconList = (props) => {
  return (
    <div className={classes.Steps}>
      {getIcons(props.translations).map(el => (
        <IconTemplate
          name={el.name}
          label={el.label}
          key={el.id}
          icon={el.icon}
          currentActive={props.activeIcon}
          iconId={el.id}
        />
      ))}
    </div>
  )
}

export default iconList;


// WEBPACK FOOTER //
// ./src/components/UI/Header/IconList/IconList.js